import {
  Box,
  Button,
  Flex,
  Image,
  Stack,
  Text,
  useColorMode,
  useColorModeValue,
  IconButton,
} from "@chakra-ui/react";
import {
  TbGridDots,
  TbHome,
  TbHome2,
  TbHomeOff,
  TbMessage,
  TbMessage2Code,
  TbMessage2Share,
  TbMessages,
  TbSmartHome,
} from "react-icons/tb";
import {
  BiEnvelope,
  BiGroup,
  BiMessage,
  BiMessageCheck,
  BiSolidEnvelope,
} from "react-icons/bi";
import {
  MdCreditCard,
  MdOutlineAttachMoney,
  MdOutlineCreditCard,
  MdOutlineOndemandVideo,
  MdOutlineTv,
  MdOutlineTvOff,
  MdTv,
} from "react-icons/md";
import { FiPieChart, FiVideo } from "react-icons/fi";
import { BsFillCreditCardFill } from "react-icons/bs";
import { MdSettings } from "react-icons/md";
import { GoHomeFill } from "react-icons/go";
import {
  AiFillAudio,
  AiFillCreditCard,
  AiFillSetting,
  AiFillVideoCamera,
  AiOutlineLogout,
  AiOutlineSetting,
  AiOutlineUser,
} from "react-icons/ai";
import { NavLink } from "react-router-dom";
import { IoLogOutSharp, IoLogOut } from "react-icons/io5";
import {
  displayForSmallDevice,
  flexDisplayForSmallDevice,
} from "../../../constants";
import googlePlay from "../../../assets/googleplaybtn.png";
import appleStore from "../../../assets/128x128.png";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "../../../service/firebase";
import { useGetState } from "../../../context/useGetState";
import { _CLEAR_ALL_SESSIONS } from "../../../components/signin/SignIn";
import { signOut } from "firebase/auth";
import { TextLogo } from "../topNav/TopNav";
import { TextNoLogo } from "../topNav/TopNav";
import useSmallScreen from "../../../components/useSmallScreen";
import { IoMdTv } from "react-icons/io";
import {
  BsFillEnvelopeFill,
  BsFillHouseFill,
  BsFillTvFill,
} from "react-icons/bs";
import { BiSolidGroup } from "react-icons/bi";
import { useLocation } from "react-router-dom";

function SideSection({ ...props }) {
  const location = useLocation();
  console.log("location", location.pathname == "/dashboard");
  const sidebarTextColor = useColorModeValue("#222222", "#fff");
  const bgColor1 = useColorModeValue("#F0F0F0", "#030c1b");
  const btnBgColor = useColorModeValue("#FFBB00", "#0076FF");
  const btnTextColor = useColorModeValue("#212121", "#fff");

  const textColor1 = useColorModeValue("#222222", "#fff");
  const [smallScreen, midScreen] = useSmallScreen();
  const logoutColor = useColorModeValue("#A7A7A7", "#A7A7A7");
  const sidebarBg = useColorModeValue("#fff", "#020b19");
  const ligtActiveBgColor = useColorModeValue("#F9FAFC", "#020b19");

  const { colorMode } = useColorMode();
  const { state } = useGetState();
  const userId = state?.userInfo?.firebase_token;

  const navStyle = {
    direction: "row",
    alignItems: "center",
    spacing: "20px",
  };

  const navList = [
    { text: "Discover", link: "/", icon: GoHomeFill },
    {
      text: "Messaging",
      link: "/messaging",
      icon: BiSolidEnvelope,
    },
    {
      text: "Groups",
      link: "/group",
      icon: BiSolidGroup,
    },
    {
      text: "LiveStream (beta)",
      link: "/live-streaming",
      icon: AiFillVideoCamera,
    },
    { text: "Meetings", link: "/meetings", icon: BsFillTvFill },
    {
      text: "Profile",
      link: "/profile",
      icon: AiFillSetting,
    },
    // {
    //   text: "Earnings",
    //   link: "/earnings",
    //   icon: AiFillCreditCard,
    // },
  ];

  const setOffline = async () => {
    const onlineState = await getDoc(doc(db, "isOnline", userId));
    if (onlineState.exists()) {
      await updateDoc(doc(db, "isOnline", userId), {
        online: false,
      });
    } else {
      await setDoc(doc(db, "isOnline", userId), {
        online: false,
      });
    }
  };

  const handleLogout = async () => {
    if (userId) {
      await setOffline();
    }

    if (auth) {
      console.log("logoutAuth: ", auth);
      await signOut(auth);
    }

    _CLEAR_ALL_SESSIONS();

    window.location.href = "/login";
  };

  const removePrivateChat = () => {
    localStorage.getItem("privateChatRecipient")
      ? localStorage.removeItem("privateChatRecipient")
      : localStorage.removeItem("privateChatRecipient");
  };

  return (
    <Stack
      // spacing={["-10px", 8]}
      spacing={["-10px", "50px"]}
      h={["100%", "100vh"]}
      alignItems={props.isOpen ? "center" : "center"}
      // justifyContent={"space-evenly"}
      justifyContent={props.isOpen ? "space-evenly" : "center"}
      direction={["row", "column"]}
      bg={[sidebarBg, "unset"]}
      {...props}
    >
      {!smallScreen && props.isOpen ? (
        <TextLogo isOpen={props.isOpen} onToggle={props.onToggle} />
      ) : (
        <TextNoLogo onToggle={props.onToggle} />
      )}
      <style>{`
      .notActive .icon-class{
        color: #A7A7A7;
      }
      `}</style>

      {navList.map(({ text, icon: Icon, link }, id) => {
        const handleClick = () => {
          if (link === "/messaging") {
            removePrivateChat();
          }
        };
        if (text == "Discover") {
          console.log("here", location.pathname == "/dashboard");
        }

        return (
          <NavLink
            to={link}
            key={id}
            className={({ isActive }) =>
              isActive ||
              (text == "Discover" && location.pathname == "/dashboard")
                ? "activeClass"
                : "notActive"
            }
            style={({ isActive }) =>
              isActive ||
              (text == "Discover" && location.pathname == "/dashboard")
                ? {
                    ...(colorMode === "light"
                      ? {
                          background: "#001C3C",
                          color: "#fff",
                          padding: "10px 15px",
                          borderRadius: "5px",
                          boxShadow: "2px 2px 7px 0px #000",

                          width: props.isOpen ? "200px" : "50px",
                        }
                      : {
                          background: "#0276fc",
                          color: "#fff",
                          padding: "10px 15px",
                          borderRadius: "5px",
                          boxShadow: "2px 2px 7px 0px #0276fc",
                          width: props.isOpen ? "200px" : "50px",
                          // width: smallScreen
                          //   ? "initial"
                          //   : midScreen
                          //   ? "100px"
                          //   : props.isOpen
                          //   ? "200px"
                          //   : "50px",
                        }),
                  }
                : {
                    color: sidebarTextColor,
                    padding: "10px 15px",
                    fontWeight: "bold",
                    width: props.isOpen ? "200px" : "50px",
                  }
            }
            // _hover={{ bg: "#001C3C", color: "#fff" }}
            onClick={handleClick}
          >
            <Stack key={id} {...navStyle}>
              <Box>
                <Icon
                  className={({ isActive }) =>
                    isActive ? "activeClass" : "notActive"
                  }
                  fontSize={"1.5em"}
                />
              </Box>
              {props.isOpen && (
                <Text
                  fontWeight={"light"}
                  fontSize={".9em"}
                  display={displayForSmallDevice}
                >
                  {text}
                </Text>
              )}
            </Stack>
          </NavLink>
        );
      })}

      <Flex
        className={"activeClass"}
        flexDirection={"row"}
        p="10px 10px"
        cursor={"pointer"}
        onClick={() => {
          handleLogout();
        }}
        // color={logoutColor}
        color={"#E61313"}
        display={"none"}
      >
        <IoLogOutSharp fontSize={"1.5em"} size={".9em"} />
        <Text fontSize={".8em"} color="#FE4045" display={displayForSmallDevice}>
          Log Out
        </Text>
      </Flex>
      {!smallScreen && (
        <Stack
          mt="45px !important"
          bg={bgColor1}
          p="10px"
          borderRadius={"10px"}
          position="relative"
          justifyContent={"center"}
          alignItems="center"
          maxW="120px !important"
          pt="45px"
          textAlign={"center"}
          alignSelf="center"
          display={"none"}
        >
          <Image
            position={"absolute"}
            top="-30px"
            transform={"translate(15px, 0px)"}
            w="70px"
            border={"1px solid #382CC6"}
            borderRadius={"50%"}
            src=""
            alt="upgrade"
            fallbackSrc="https://via.placeholder.com/150"
          />
          <Text color={textColor1} fontSize=".9em" display={"none"}>
            Try Premium
          </Text>
          <Button
            bg={btnBgColor}
            color={btnTextColor}
            size="xs"
            fontWeight={"300"}
          >
            Upgrade Now
          </Button>{" "}
        </Stack>
      )}

      {!smallScreen && (
        <Stack
          alignItems="center"
          mt="auto !important"
          mb="30px !important"
          w="100%"
          display={flexDisplayForSmallDevice}
          direction={"row"}
        >
          {/* <Button
            size="xs"
            h="50px"
            w="90%"
            bg={"#FE4045"}
            color="#fff"
            boxShadow={"2px 2px 7px 0px #FE4045"}
            gap={"10px"}
            onClick={() => {
              handleLogout();
            }}
          >
            <AiOutlineLogout
              fontSize={"1.5em"}
              size={".9em"}
              mr="5px !important"
            />
            <Text>Logout</Text>
          </Button> */}
          <Flex
            cursor={"pointer"}
            className={"activeClass"}
            // {...navStyle}
            gap="20px"
            mb={1}
            alignItems={"center"}
            justifyContent={"center"}
            // p="10px 10px"
            flexDirection={"row"}
            onClick={() => {
              handleLogout();
            }}
            // boxShadow={"2px 2px 7px 0px #FE4045"}
            style={{
              background: "red",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "5px",
              boxShadow: "2px 2px 7px 0px red",

              width: props.isOpen ? "200px" : "50px",
            }}
          >
            <IoLogOutSharp />
            {props.isOpen && (
              <Text display={displayForSmallDevice}>Log Out</Text>
            )}
          </Flex>

          <Image
            display={"none"}
            w="90px"
            h="30px"
            objectFit={"cover"}
            src={googlePlay}
            alt="google play"
          />
          <Image
            display={"none"}
            w="90px"
            h="30px"
            objectFit={"cover"}
            src={appleStore}
            alt="apple store"
          />
        </Stack>
      )}
    </Stack>
  );
}

export default SideSection;
